<!--  -->

<template>
  <div class="content">
    <!-- banner -->
    <div class="banner">
      <img @click="jump" src="../../assets/img/haotong/banner.png" alt="" />
    </div>
    <!-- nav -->
    <div class="navText">
      <div class="navIitem" @click="NavTop(index)" 
      :class="active==index?'active':''" v-for="(item, index) in navList" :key="index">
        {{ item.text}}
      </div>
    </div>
    <!-- 智能通关系统功能特点 -->
    <div class="intelligence">
      <!-- <div class="img">
        <img src="../../assets/img/haotong/bg.png" alt="" />
      </div> -->
      <div class="card flex">
        <div class="in_left">
          <div class="all_text">
            <img src="../../assets/img/index/ico.png" alt="" />
            <div class="text">智能通关系统 <br />功能特点</div>
            <div class="row"></div>
          </div>
          <!-- 下面的ico -->
          <div class="in_list">
            <div class="li" v-for="(item, index) in listNew" :key="index">
              <div class="left">
                <img :src="item.img" alt="" />
              </div>
              <div class="right">
                <div class="title">{{ item.title }}</div>
                <div class="text">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="in_right">
        <img src="../../assets/img/haotong/img.png" alt="" />
      </div> -->
    </div>
    <!-- 系统主要功能及作用 -->
    <div class="sys_do card">
      <Link text="系统主要功能及作用" />
      <div class="list_ico">
        <div v-for="(item, index) in do_list" :key="index" class="li" :class="index == current ? 'bg_img' : ''"
          @mouseenter="bcolor(index)" @mouseleave="wcolor" :style="index == 0 || index == 2 ? 'margin-top:70px' : ''">
          <img :src="index == current ? item.img1 : item.img" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      listNew:[],
      list: [
        {
          title: "通关数字化",
          text: "支持批量导入和一键复制制单，提高制单效率，降低操作差错，实时掌握通关状态。",
          img: require("../../assets/img/haotong/1.png"),
        },
        {
          title: "多方协同操作",
          text: "支持关务物流作业全程电子化及关务物流协同操作，智能提取物流数据，实现流程化管控。",
          img: require("../../assets/img/haotong/2.png"),
        },
        {
          title: "全流程追溯",
          text: "实现货物流、单证流、信息流三流合一，业务数据关联追溯和相互印证，满足穿行测试要求。",
          img: require("../../assets/img/haotong/3.png"),
        },
        {
          title: "三方数据对接",
          text: "支持ERP+关务+单一窗口对接，实现进出口业务数据实时同步，加快申报效率，减少人力成本，降低申报差错。",
          img: require("../../assets/img/haotong/4.png"),
        },
        {
          title: "可视化平台",
          text: "关务数据看板，可视化数据分析与统计，关务标准化查询，可视化复核和报表。",
          img: require("../../assets/img/haotong/5.png"),
        },
        {
          title: "风险管控",
          text: "全方位进出口及贸易合规风险预警和多项智能合规校验提醒，规范报关流程合规。",
          img: require("../../assets/img/haotong/6.png"),
        },
      ],
      lists: [
        {
          title: "业务流程化",
          text: "支持生产+采购+销售+仓储+报关+物流+财务等业务全流程操作，实时监控业务全流程动态，提升工作效率，减少人力成本，降低操作差错。",
          img: require("../../assets/img/haotong/3.png"),
        },
        {
          title: "通关数字化",
          text: "支持批量导入和一键复制制单，提高制单效率，降低操作差错，实时掌握通关状态。",
          img: require("../../assets/img/haotong/1.png"),
        },
        {
          title: "全流程追溯",
          text: "实现货物流、单证流、信息流三流合一，业务数据关联追溯和相互印证。",
          img: require("../../assets/img/haotong/3.png"),
        },
        {
          title: "无纸化通关",
          text: "国际贸易单一窗口一键对接申报，实现进出口业务数据实时同步和查询报关状态。",
          img: require("../../assets/img/haotong/5.png"),
        },
        {
          title: "智能化配置",
          text: "全方位进出口及贸易合规风险预警和多项智能合规校验提醒；灵活设置业务审批流程，满足客户个性化需求，快速、稳定、安全。",
          img: require("../../assets/img/haotong/2.png"),
        },
        {
          title: "风险管控",
          text: "全方位进出口及贸易合规风险预警和多项智能合规校验提醒，规范报关流程合规。",
          img: require("../../assets/img/haotong/6.png"),
        },
      ],
      current: -1,
      do_list: [
        {
          title: "报关单据",
          text: "一键生成、导出、打印标准格式报关单",
          img: require("../../assets/img/haotong/bgdj1.png"),
          img1: require("../../assets/img/haotong/bgdj.png"),
        },
        {
          title: "数据追查",
          text: "可查询，可追溯报关后数据信息",
          img: require("../../assets/img/haotong/jgmy1.png"),
          img1: require("../../assets/img/haotong/jgmy.png"),
        },
        {
          title: "客户接口",
          text: "与企业ERP系统对接，无需人工录入，减少差错，降低人工成本",
          img: require("../../assets/img/haotong/khjk1.png"),
          img1: require("../../assets/img/haotong/khjk.png"),
        },
        {
          title: "客户管理",
          text: "管理企业旗下账号及权限分配",
          img: require("../../assets/img/haotong/khgl1.png"),
          img1: require("../../assets/img/haotong/khgl.png"),
        },
      ],
      navList: [
        {
          text: "物流通关信息管控系统 【 标准版 】",
        },
        {
          text: "海驼关务管理系统 【 企业版 】",
        },
      ],
      active:0
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    NavTop(index){
      this.active=index;
      if(this.active==0){
        this.listNew=this.list;
      }else{
        this.listNew=this.lists;
      }
    },
    bcolor(e) {
      this.current = e;
    },
    wcolor() {
      this.current = -1;
    },
    // 底部
    jump(index) {
      let jump = document.getElementById("d_jump");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { 
    this.NavTop(0);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped lang='less'>
@import url(../Haotong/pc);
.navText {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  cursor: pointer;
}
.navIitem{
  margin: 0 60px;
  padding:15px 0;
  font-size: 16px;
}
.active{
  border-bottom: 2px solid rgba(18, 87, 227, 1);
  color: rgba(18, 87, 227, 1);
  font-weight: bold;
  
}
</style>